// NoChildrenIcon.jsx
import React from "react";

const NoChildrenIcon = () => {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: "24px",
        padding: "3.5px",
      }}
    >
      <circle cx="50" cy="50" r="50" />
    </svg>
  );
};

export default NoChildrenIcon;
